import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import point_icon from '../../static/images_ae/pointsMall/point_icon.png';
import points_all from '../../static/images_ae/pointsMall/points_all.png';
import no_content_point from '../../static/images_ae/no_content_point.png';
import { withRouter } from 'react-router-dom';
import { InfiniteScroll } from 'antd-mobile-v5';
import styles from './index.module.scss';

const api = new ApiCore();

const AePointsRecords = (props: any) => {

    const [pointCount, setPointCount] = useState<any>(null);
    const [list, setList] = useState<any>([]);
    const [hasMore, setHasMore] = useState(true);
    const [curPage, setCurPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState<any>(null);
    const [listReady, setListReady] = useState<any>(false);

    useEffect(() => {
        window.document.title = '获取记录';
        initData();
    }, [])

    const initData = () => {
        api.toGetAeAllCount().then((res: any) => {
            if (res.code == 0) {
                setPointCount(res.data);
            }
        })
        // api.getAePointRecords({
        //     type: 'add'
        // }).then((res: any) => {
        //     if (res.code == 0) {
        //         setList(res.data.rows || []);
        //         setListReady(true);
        //     }
        // })
    }

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            if (total !== null && curPage * pageSize >= total) {
                setHasMore(false);
                resolve([]);
            }
            let _curPage = curPage;
            _curPage++;
            setCurPage(_curPage)
            api.getAePointRecords({
                type: 'add',
                page: _curPage,
                pageSize: pageSize
            }).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_curPage * pageSize >= res.data?.total) {
                        setHasMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }

    
    async function loadMore() {
        const append = await getData();
        setList((val: any) => [...val, ...append]);
        setListReady(true);
    }

    return (
        <div className={styles.ae_points_records}>
            <div className={styles.head}>
                <img className={styles.point_card} src={points_all} alt="" />
                <div className={styles.head_text}>
                    <div className={styles.head_text_title}>积分总数</div>
                    <div className={styles.head_text_count}>{pointCount}</div>
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.body_title}>
                    积分获取明细
                </div>
                <div className={styles.body_content}>
                {
                    list.map((val: any, key: number) => 
                    (<div key={key} className={styles.body_content_item}>
                        <div className={styles.body_content_item_left}>
                            <div className={styles.body_content_item_left_top}>{val.remark}</div>
                            <div className={styles.body_content_item_left_bottom}>{val.createTime ? 
                                val.createTime.replace('T', ' ') : ''
                            }</div>
                        </div>
                        <div className={styles.body_content_item_right}>
                            <img src={point_icon} alt="" />
                            <span>+ {val.integral}</span>
                        </div>
                    </div>))
                }
                {
                    listReady && list.length == 0 &&
                    <div className={styles.no_content}>
                        <img src={no_content_point} alt="" />
                    </div>
                }
                <InfiniteScroll loadMore={loadMore} hasMore={hasMore} >{''}</InfiniteScroll>
                </div>
            </div>
        </div>
    )
}

export default withRouter(AePointsRecords);